import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Services from "./components/Services";
import WhyFieldstech from "./components/WhyFieldstech";
import Footer from "./components/Footer";
import DiagnosticoGratuito from "./components/DiagnosticoGratuito";
import Contacto from "./pages/Contacto";
import Gracias from "./pages/Gracias";

const Home = () => {
  return (
    <div>
      <Navbar />
      <Hero />
      <Services />
      <WhyFieldstech />
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/diagnostico-gratuito" element={
            <>
              <Navbar />
              <DiagnosticoGratuito />
            </>
          } />
          <Route path="/contacto" element={
            <>
              <Navbar />
              <Contacto />
            </>
          } />
          <Route path="/gracias" element={
            <>
              <Navbar />
              <Gracias />
              <Footer />
            </>
          } />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
